import { Component, Input } from '@angular/core';
import { RequeteModifierCoordonnees } from 'src/app/api/model/requete-modifier-coordonnees.model';

@Component({
  selector: 'app-valider-coordonnees',
  templateUrl: './valider-coordonnees.component.html',
  standalone: false,
})
export class ValiderCoordonneesComponent {
  @Input() requeteModifierCoordonnees: RequeteModifierCoordonnees;

  constructor() {}
}
